/* eslint-disable import/no-unresolved */
import Header from "src/shared/Header";
import CreateNewLeadDetails from "src/components/NewLeadDetails";

function NewLeadPage() {
  return (
    <div>
      <Header isEnable />
      <CreateNewLeadDetails />
    </div>
  );
}

export default NewLeadPage;
